import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getnavxhtml, sendnavxhtml } from "../../api/api";
import { toast } from "react-toastify";

const Guideline = ({ fileId, renderpage }) => {
  const [apiData, setApiData] = useState([]);
  const [options, setOptions] = useState([]);
  const [guidetext, setGuideText] = useState([]);
  const { category } = useParams();
  const [stage, setStage] = useState();

  useEffect(() => {
    fetchdata(fileId);
  }, [fileId]);

  const fetchdata = async (currentFileId) => {
    try {
      let data = await getnavxhtml(currentFileId, category);
      if (data.data) {
        console.log(data.data);
        setOptions(data.data.change);
        setApiData(data.data.tags);
        setGuideText(data.data.guide_text || []);
        setStage({
          previous: data.data.previous_process,
          next: data.data.next_process,
        });
      } else {
        // alert(data.error);
        toast.error(data.error.message);
      }
    } catch (e) {
      // alert(e);
      toast.error(e);
    }
  };

  useEffect(() => {
    if (apiData) {
      setGuideText(includeEpub(guidetext, apiData));
    }
  }, [apiData]);

  const includeEpub = (guidetext, apiData) => {
    let newguide = guidetext.map((ele, i) => {
      let newObject = { ...ele, epub_type: apiData[i]?.epub_type };
      return newObject;
    });
    return newguide;
  };

  const handleChange = (e, items, index) => {
    const userInput = e.target.value;

    setGuideText((prev) => {
      // Ensure prev is an array and update the specific index
      const updatedGuideText = [...prev];
      updatedGuideText[index] = {
        ...updatedGuideText[index],
        text: userInput,
      };
      return updatedGuideText;
    });
  };

  const senddata = async (event) => {
    const button = event.currentTarget;
    button.disabled = true; // Disable the button
    document.body.style.cursor = "wait";
    try {
      if (apiData) {
        button.disabled = true;
        document.body.style.cursor = "wait";
        let response = await sendnavxhtml(fileId, guidetext, category);
        if (response.data) {
          document.body.style.cursor = "default";
          handleNext(fileId, stage.next);
        } else {
          // alert(response.error.message);
          toast.error(response.error.message);
          button.disabled = false;
          document.body.style.cursor = "default";
        }
      }
    } catch (e) {
      // console.log(e);
      toast.error(e);
      button.disabled = false;
      document.body.style.cursor = "default";
    }
  };

  const handleNext = (fileId, nextpage) => {
    renderpage(fileId, nextpage);
  };

  return (
    <div className="flex flex-col w-full">
      <div className="p-8 flex flex-col gap-8 h-[100%] min-h-[70vh]">
        <div className="flex w-full justify-between text-left items-center">
          <h1 className="text-24 font-semibold">Guideline Nav. XHTML</h1>
          <button
            onClick={() => toast.info("Feature yet to be implemented")}
            className="flex gap-2 px-3 py-3 border-[1.5px] border-highlighttext rounded-[12px]"
          >
            <img
              src={process.env.PUBLIC_URL + "/images/gotoeditor.svg"}
              alt="editor_logo"
            ></img>
            <p className="text-highlighttext text-14 font-semibold">
              Go to Editor
            </p>
          </button>
        </div>
        <div className="overflow-auto max-h-[600px] rounded-[16px] border-[1px] border-commonborder shadow-commonshadow">
          <table className="w-full ">
            <thead className="sticky top-0 z-10 bg-tableheadingbg px-4 py-6 text-left text-white text-16 font-semibold">
              <tr className="">
                <th className="px-4 py-5">HTML Name</th>
                <th className="px-4 py-5">ePub Type</th>
                <th className="px-4 py-5">Guide Title Text</th>
              </tr>
            </thead>
            <tbody className="w-full text-left bg-white">
              {apiData?.map((items, i) => (
                <tr
                  key={i}
                  className="border-b-[1px] border-commonborder last:border-none"
                >
                  <td className="px-4 py-5" style={{ width: "20%" }}>
                    <p className="px-4 py-3 rounded-[8px] bg-commonfill">
                      {items.html}
                    </p>
                  </td>

                  <td className="px-4 py-5 relative">
                    {
                      <p className="px-4 py-3 rounded-[8px] bg-commonfill">
                        {items.epub_type !== ""
                          ? items.epub_type
                          : "No data found"}
                      </p>
                    }
                    {/* <select
                      className="rounded-[8px] bg-commonfill px-4 py-3 w-full appearance-none"
                      style={{ accentColor: "#FF6A00" }}
                    >
                      <option>H!:Ch</option>
                      <option>para</option>
                      <option>heading</option>
                    </select>
                    <svg
                      class="absolute top-1/2 right-8 transform -translate-y-1/2 w-4 h-4 text-gray-500 pointer-events-none"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M19 9l-7 7-7-7"
                      ></path>
                    </svg> */}
                  </td>
                  <td className="px-4 py-5">
                    {" "}
                    <input
                      type="text"
                      onChange={(e) => handleChange(e, items, i)}
                      value={guidetext[i]?.text || ""}
                      className="px-4 py-3 rounded-[8px] bg-commonfill outline-none w-full"
                      title={
                        (guidetext[i]?.text.length > 30 &&
                          guidetext[i]?.text) ||
                        ""
                      }
                    ></input>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex ml-auto gap-5">
          <button
            onClick={(event) => {
              handleNext(fileId, stage.previous);
            }}
            className="w-fit mt-20 flex "
          >
            <p className="py-3 px-6 rounded-[12px] text-white bg-highlight text-14 font-bold">
              PREV
            </p>
          </button>
          <button
            onClick={(event) => {
              senddata(event);
            }}
            className="w-fit mt-20 flex"
          >
            <p className="py-3 px-6 rounded-[12px] text-white bg-highlight text-14 font-bold">
              NEXT
            </p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Guideline;
